/* tslint:disable */
/* eslint-disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type auctionsRoutes_AuctionsQueryVariables = {};
export type auctionsRoutes_AuctionsQueryResponse = {
    readonly me: {
        readonly " $fragmentRefs": FragmentRefs<"AuctionsApp_me">;
    } | null;
};
export type auctionsRoutes_AuctionsQuery = {
    readonly response: auctionsRoutes_AuctionsQueryResponse;
    readonly variables: auctionsRoutes_AuctionsQueryVariables;
};



/*
query auctionsRoutes_AuctionsQuery {
  me {
    ...AuctionsApp_me
    id
  }
}

fragment AuctionsApp_me on Me {
  id
}
*/

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "auctionsRoutes_AuctionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AuctionsApp_me"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "auctionsRoutes_AuctionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "auctionsRoutes_AuctionsQuery",
    "operationKind": "query",
    "text": "query auctionsRoutes_AuctionsQuery {\n  me {\n    ...AuctionsApp_me\n    id\n  }\n}\n\nfragment AuctionsApp_me on Me {\n  id\n}\n"
  }
};
(node as any).hash = '6f609b915ab28c11abe221d1ed6ea1ba';
export default node;
